import script from "./DashboardsList.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardsList.vue?vue&type=script&setup=true&lang=js"

import "./DashboardsList.vue?vue&type=style&index=0&id=8c71e356&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c71e356"]])

export default __exports__